import './index.css'
import React, { useState } from 'react'
import { Typography, Box } from '@mui/material'

const FormInput = ({
  className,
  id,
  value = '',
  onChange,
  label,
  placeHolder,
  validator,
  showError = true,
  hideErrorWhenEmpty = false,
  errorLabel,
  maxLength,
  required,
  type,
  bgwhite,
  ...rest
}) => {
  const [firstTime, setFirstTime] = useState(true)

  if (!validator) {
    return (
      <div className={className ? className + ' form-input-wrapper' : 'form-input-wrapper'} {...rest}>
        {label && (
          // <label className="color-primary form-input-label" htmlFor={id}>
          <Typography variant="body2M">{label}</Typography>
        )}
        <input
          id={id}
          value={value}
          type={type ? type : undefined}
          maxLength={maxLength ? maxLength : undefined}
          onChange={e => onChange(id, e.target.value)}
          placeholder={placeHolder}
          {...rest}
        ></input>
      </div>
    )
  } else {
    return (
      <div className={className ? className + ' form-input-wrapper' : 'form-input-wrapper'} {...rest}>
        {label && (
          // <label className="color-primary form-input-label" htmlFor={id}>
          <Typography variant="body2M" color="#25245F">
            {label}
            {required ? <Box component='span' color='#D14343'>&nbsp;*</Box> : null}
          </Typography>
        )}
        <input
          id={id}
          value={value}
          bgwhite={bgwhite}
          required={required}
          type={type ? type : undefined}
          maxLength={maxLength ? maxLength : undefined}
          style={{
            outlineColor: !firstTime && !validator(value) ? 'red' : '',
            border:
              !firstTime && !validator(value) && showError
                ? '1px solid #D14343'
                : !bgwhite
                ? '1px solid #D3D3DF'
                : '1px solid #fff',
            backgroundColor: !firstTime && !validator(value) && showError ? '#FDF6F6' : '#fff',
            caretColor: !bgwhite ? '#25245f' : '#0a78cd',
          }}
          onBlur={() => setFirstTime(false)}
          onFocus={() => setFirstTime(true)}
          onChange={e => {
            onChange(id, e.target.value)
          }}
          placeholder={placeHolder}
          {...rest}
        ></input>
        {!firstTime && showError && !validator(value) && (
          <label className="form-input-error" htmlFor={id}>
            {errorLabel || 'Required'}
          </label>
        )}
      </div>
    )
  }
}

export default FormInput
